import api from './api';

interface Producto {
    codigoArticulo: string;
    descripcion: string;
    costo?: number;
    // otros campos que pueda tener el producto
}

interface ProductoSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

interface ProductoPagedResult {
    items: Producto[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

interface ProductoBulkError {
    indice: number;
    codigoArticulo: string;
    mensaje: string;
}

interface ProductoBulkResult {
    exitosos: number;
    fallidos: number;
    errores: ProductoBulkError[];
}

const productoService = {
    getProducto: async (codigoArticulo: string): Promise<Producto> => {
        const response = await api.get<Producto>(`/api/productos/${codigoArticulo}`);
        return response.data;
    },
    actualizarCantidad: async (codigoArticulo: string, cantidad: number, tipoAjuste: string, nroUbicacionOrigen?: number, nroUbicacionDestino?: number) => {
        const response = await api.put(`/api/productos/actualizarCantidad`, {
            codigoArticulo,
            cantidad,
            tipoAjuste,
            nroUbicacionOrigen,
            nroUbicacionDestino
        });
        return response.data;
    },
    getProductos: async (params: ProductoSearchParams): Promise<ProductoPagedResult> => {
        const response = await api.get<ProductoPagedResult>('/api/Productos', { params });
        return response.data;
    },
    createProducto: async (producto: Producto) => {
        const response = await api.post('/api/productos', producto);
        return response.data;
    },
    createProductosBulk: async (productos: any[]): Promise<ProductoBulkResult> => {
        const response = await api.post<ProductoBulkResult>('/api/Productos/Bulk', productos);
        return response.data;
    },
};

export default productoService; 